var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Cdnrecords"}},[_c('a',{attrs:{"href":"https://cdnrecords.com/shop/mortor-burn-up-the-dead/","target":"_blank"}},[_c('img',{staticClass:"site-crest",attrs:{"alt":"CDN Records logo","src":require("../assets/cdn-logo-crest.svg")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef47972","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cdnrecords.vue
// module id = null
// module chunks = 